export const locale = {
    lang: 'pl',
    data: {
        "Name": "Nazwa",
        "Phone": "Telefon",
        "Actions": "Akcje",
        "Edit": "Edycja",
        "Suppliers": "Dostawcy",
        "New": "Nowy"
    }
};
